// extracted by mini-css-extract-plugin
module.exports = {"fast":"150","medium":"300","slow":"600"};